module.exports = __webpack_public_path__ + "static/919_mexico_logo_en-0173ddb6d5f5390e62186c3d97de3fd8.svg";